import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const getListingCompatibilityList = createAsyncThunk('compatibility/getListingCompatibilityList',
  async (listingId, { rejectWithValue }) => {
    try {
      const { data } = await authGet(`/compatibility/${listingId}`);
      if (data?.message) {
        return rejectWithValue(data.message);
      }
      return data;
    } catch (error) {
      return rejectWithValue(error?.data.message);
    }
  });

export const setListingCompatibilityList = createAction('compatibility/getListingCompatibilityList');

export default getListingCompatibilityList;
